import React, { useState, useEffect } from 'react';
import { Card, Form, Row, Col, Radio, AutoComplete, Space, Select, Switch, Button, Spin, DatePicker } from 'antd';
import { excelExportMultipleTables } from '../../Utils/ExportMultipleTables';
import { errHandler } from '../../helper/helper';
import { bsNotesBranchWiseReport } from './GeneralService';
import { disabledDate } from "../../Utils/Util";
import moment from 'moment';


const { Option, OptGroup } = Select;

const DistrictBsNodesReport = ({
    loginPlaceId,
    districtData,
    districtName,
}) => {
    const [selectedDistricts, setSelectedDistricts] = useState([]);
    const [availableBranches, setAvailableBranches] = useState([]);
    const [selectedBranches, setSelectedBranches] = useState([]);
    const [date, setDate] = useState(null)
    const [reportLoading, setReportLoading] = useState(false)



    // Update available branches based on selected districts
    useEffect(() => {
        const filtered = districtData
            .filter(d => selectedDistricts.includes(d.districtId))
            .flatMap(d => d.branchDtoList || []);
        setAvailableBranches(filtered);

        // Remove unlisted branches if previously selected
        setSelectedBranches(prev => prev.filter(bid =>
            filtered.some(b => b.id === bid)
        ));
    }, [selectedDistricts, districtData]);

    const generateBsNodeReport = async () => {
        let data = {
            branchIdList: selectedBranches,
            selectedDate: date,
            reportId: 2
        }
        try {
            const res = await bsNotesBranchWiseReport(data);
            console.log(res);
            return res; // ✅ Now you're returning it from getDistrictData
        } catch (err) {
            errHandler(err);
            throw err; // optionally rethrow so caller knows it failed
        }
    }

    const selectedDistrictNames = districtData
        .filter(d => selectedDistricts.includes(d.districtId))
        .map(d => d.districtName)
        .join(", ");


    const dateTimeNow = moment().format('YYYY-MM-DD_HH-mm-ss'); // e.g., 2025-06-05_14-30-12

    const handleExport = async () => {
        setReportLoading(true)
        try {
            const memeberAndShare = await generateBsNodeReport();
            const data = memeberAndShare.data || [];
            const formattedDate = moment(date).format('YYYY-MM-DD'); // or any format you want

            const tables = [
                {
                    tableTitle: "Branch Wise Statement Summary Report -" + formattedDate + "-" + (selectedDistrictNames),
                    data,
                    rowCategoryFunction: item => `${item.ledgerName} (${item.ledgerCode})`,

                    rowCategories: [...new Set(data.map(item => `${item.ledgerName} (${item.ledgerCode})`))],
                    // rowCategoryFunction: item => item.ledgerName,
                    columnGroupKeyFunction: item => item.branchName,
                    columnGroups: [
                        {
                            subColumns: [
                                {
                                    label: 'Amount',
                                    valueExtractor: item => item.amount || 0
                                }
                            ]
                        }
                    ],
                    grandTotalSubHeaders: ['Amount'],
                    subHeaderStyles: {
                        Amount: { fillColor: '#FDE9D9' }
                    }
                }
            ];


            console.log("tables e", tables);


            // Only export if there is at least one table
            if (tables.length > 0) {
                excelExportMultipleTables({
                    tables, totalRowStyle: {
                        fillColor: '#BDD7EE', // Light blue
                        fontColor: '#000000', // Black text
                        bold: true
                    }, fileName: (
                        selectedDistrictNames.includes(',')
                            ? "District Financial Report"
                            : `${selectedDistrictNames} - Branch Wise Financial Report`
                    ) + ` - ${dateTimeNow}.xlsx`

                });
            } else {
                console.warn("No data available to export.");
            }
        } catch (error) {
            errHandler(error)
        } finally {
            setReportLoading(false)
        }
    };

    return (
        <div className="panel-container">
            <Card hoverable className="inner-card">
                <Form layout="vertical">
                    <Row gutter={[16, 16]}>
                        <Col span={24}>
                            <Form.Item label="Select Districts">
                                <Select
                                    mode="multiple"
                                    placeholder="Select districts"
                                    style={{ width: '100%' }}
                                    value={selectedDistricts}
                                    onChange={setSelectedDistricts}
                                >
                                    {districtData
                                        .filter(d => loginPlaceId === "4" ? d.districtName === districtName : true)
                                        .map(d => (
                                            <Option key={d.districtId} value={d.districtId}>
                                                🏙️ {d.districtName}
                                            </Option>
                                        ))}
                                </Select>
                            </Form.Item>
                        </Col>

                        <Col span={24}>
                            <Form.Item label="Select Branch(es)">
                                <Select
                                    mode="multiple"
                                    placeholder="Select branches"
                                    style={{ width: '100%' }}
                                    value={selectedBranches}
                                    onChange={(values) => {
                                        if (values.includes('ALL')) {
                                            setSelectedBranches(availableBranches.map(b => b.id));
                                        } else {
                                            setSelectedBranches(values);
                                        }
                                    }}
                                    disabled={availableBranches.length === 0}
                                >
                                    <Option key="ALL" value="ALL">
                                        🔘 Select All Branches
                                    </Option>
                                    {availableBranches.map(branch => (
                                        <Option key={branch.id} value={branch.id}>
                                            🏢 {branch.branchName}
                                        </Option>
                                    ))}
                                </Select>
                            </Form.Item>
                        </Col>
                        <Col span={24}>
                            <Form.Item label="Select Date">
                                <DatePicker onChange={(date) => setDate(date)} disabledDate={disabledDate} style={{ width: '100%' }} />
                            </Form.Item>
                        </Col>

                        {/* Submit button */}
                        <Col span={24}>
                            <Form.Item className="generate-btn-outline">
                                <Button
                                    onClick={handleExport}
                                    disabled={reportLoading}
                                    className="generate-btn"
                                    style={{ textAlign: 'right' }}
                                >
                                    {reportLoading ? <Spin /> : 'Generate Report'}
                                </Button>
                            </Form.Item>
                        </Col>
                    </Row>
                </Form>
            </Card>
        </div>
    );
};

export default DistrictBsNodesReport;
